export default __webpack_public_path__ + "static/media/info-white.f49e784f.svg";